var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-notification"},[_c('div',{staticClass:"titleSchedule",domProps:{"innerHTML":_vm._s(_vm.$t('plane'))}}),_c('div',[_vm._v("Нет данных")])])}
var staticRenderFns = []

export { render, staticRenderFns }